export default null;throw new Error("Unable to resolve \"./lib/_stream_duplex.js\" from npm:pngjs@5.0.0/browser.js");